<!-- 
程式：addNewContract.vue
功能：欲新增的契約分類
作者：i94005ws01 王子齊
完成：2020-10-29
-->
<template>
  <div class="tab-pane pt-3 active show">
    <div class="insurance-editor">
      <div class="new-insurance" :class="{ 'section-loading': isLoading }">
        <div class="row">
          <div class="col-6">
            <h4>
              請選擇欲新增的契約分類：<br /><span style="color: red;">
                ※請務必取得客戶本人同意後，再建立客戶保單資料。</span
              >
            </h4>
          </div>
          <div class="col-6 text-right">
            <div>
              <button
                class="btn btn-default"
                @click="$router.push({ name: 'policyInfo-edit-list' })"
              >
                回上一步
              </button>
            </div>
          </div>
        </div>
        <div class="cards new-insurance-type four-card">
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'self-input-policy-number',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-tree"></i></div>
            <div class="content">
              <h4>自行輸入國泰人壽<br />保單號碼(含家庭型)</h4>
            </div>
          </div>
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'add-other-comp-contract',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-building"></i></div>
            <div class="content">
              <h4>其他同業壽險保單<br />(含保代件)</h4>
            </div>
          </div>
                     <!-- 新增：手動輸入同業壽險保單 -->
          <div 
            role="button" 
            class="card text-center position-relative" 
            @click="openManualInputWindow"
          >
            <img :src="`${BaseUrl}assets/tagicon/new.png`" alt="New" class="new-tag-icon" />
            
            <div class="icon"><i class="icon-company"></i></div>
            <div class="content">
              <h4>【新】手動輸入<br />同業壽險保單<br />(含保代件)</h4>
            </div>
          </div>
            <!-- 新增：拍照上傳同業壽險保單 -->
          <div v-if="isOcrEnabled"
            role="button" 
            class="card text-center position-relative" 
            @click="openPhotoUploadWindow"
          >
          <img :src="`${BaseUrl}assets/tagicon/new.png`" alt="New" class="new-tag-icon" />
            <div class="icon"><i class="icon-union"></i></div>
            <div class="content">
              <h4>【新】拍照上傳<br />同業壽險保單<br />(含保代件)</h4>
            </div>
          </div>
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'insurance-note',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-note"></i></div>
            <div class="content"><h4>其他保單筆記</h4></div>
          </div>
        </div>
        <!-- <div class="cards new-insurance-type four-card">
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'car-insurance',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-car"></i></div>
            <div class="content"><h4>車險</h4></div>
          </div>
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'fire-insurance',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-fire"></i></div>
            <div class="content"><h4>火險</h4></div>
          </div>
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'new-insurance',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-umbrella"></i></div>
            <div class="content"><h4>新種險</h4></div>
          </div>
          <div
            role="button"
            class="card text-center"
            @click="
              $router.push({
                name: 'insurance-note',
                query: { canBackToMenu: true }
              })
            "
          >
            <div class="icon"><i class="icon-note"></i></div>
            <div class="content"><h4>其他保單筆記</h4></div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import { checkUnitExist } from "@/service";
import { checkOcrSwitch } from "@/service";
export default {
  data: () => ({
    canViewCreateInsuranceMyself: false,
    isLoading: false,
    childWindow: null,
    pollingInterval: null,
    messageListener: null,
    //unitExist: false,
    isOcrEnabled: true,
    checkClosedInterval: null
  }),
methods: {
  encodeToTargetFormat(str) {
    const base64String = btoa(str);
    return encodeURIComponent(base64String);
  }, 
  startPollingForMessage() {
    const startTime = Date.now(); // 記錄開啟視窗的時間點
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    this.pollingInterval = setInterval(() => {
      const possibleKeys = [
        'childWindowMessage', 
        'policyUploadMessage', 
        'policyInfoMessage',
        'messageFromChild'
      ];
      for (const key of possibleKeys) {
        const message = localStorage.getItem(key);
        if (message) {
          try {
            const data = JSON.parse(message);
            // 如果訊息沒有 timestamp，或是 timestamp 早於開啟時間，就視為舊資料
            if (data.timestamp && data.timestamp < startTime) {
              localStorage.removeItem(key); // 刪除過期資料
              continue; // 跳過，不處理
            }
            this.processMessage(data);
            possibleKeys.forEach(k => localStorage.removeItem(k));
            this.stopPolling();
            return;
          } catch (error) {
            console.error('解析訊息失敗:', error);
          }
        }
      }
      if (!this.childWindow || this.childWindow.closed) {
        this.stopPolling();
      }
    }, 500);
  },
  processMessage(data) {
    switch (data.type) {
      case 'MANUAL_INPUT_COMPLETE':
        this.handleManualInputComplete(data.payload);
        break;
      case 'PHOTO_UPLOAD_COMPLETE':
        this.handlePhotoUploadComplete(data.payload);
        break;
      case 'OPERATION_CANCELLED':
        this.handleOperationCancelled();
        break;
    }
  },
  setupPostMessageListener() {
    this.messageListener = (event) => {
      const allowedOrigins = [
        'http://localhost:8088',
        'http://localhost:8080', 
        'https://tmycrm.cathaylife.com.tw',
        window.location.origin
      ];
      if (!allowedOrigins.includes(event.origin)) {
        return;
      }
      if (event.data && typeof event.data === 'object') {
        this.processMessage(event.data);
      }
    };
    /*window.addEventListener('message', (event) => {
      const data = event.data;  // 關鍵：使用 event.data
      if (data.type === 'MANUAL_INPUT_COMPLETE') {
        this.handleManualInputComplete(data);
      }
      if (data.type === 'PHOTO_UPLOAD_COMPLETE') {
        this.handlePhotoUploadComplete(data);
      }
      if (data.type === 'OPERATION_CANCELLED') {
        this.handleOperationCancelled(data);
      }
    });*/
    window.addEventListener('message', this.messageListener);
  },
  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    if (this.messageListener) {
      window.removeEventListener('message', this.messageListener);
      this.messageListener = null;
    }
  },
  getFamilyId() {
    if (this.$store && this.$store.getters && this.$store.getters.UserItems) {
      try {
        const userItems = typeof this.$store.getters.UserItems === 'string' 
          ? JSON.parse(this.$store.getters.UserItems) 
          : this.$store.getters.UserItems;
        const id = userItems.familyid || userItems.csidno;
        if (id) return id;
      } catch (e) {
        console.error('從 store 解析失敗:', e);
      }
    }
    if (localStorage.userItems) {
      try {
        const userItems = JSON.parse(localStorage.userItems);
        const id = userItems.familyid || userItems.csidno;
        if (id) return id;
      } catch (e) {
        console.error('從 localStorage 解析失敗:', e);
      }
    }
    if (localStorage.CustID) {
      return localStorage.CustID;
    }
    if (this.$route && this.$route.query && this.$route.query.familyId) {
      return this.$route.query.familyId;
    }
    return null;
  },
  openManualInputWindow() {
      const familyId = this.getFamilyId();
      const baseUrl = this.getCrmBaseUrl();
      // 避免重復編碼，直接使用拼接方式，原本URLSearchParams.toString 會把 == 符號轉換為%3D%3D, 
      // 在對整個內層 URL 嵌入外層encodeURIComponent 會編碼二次造成錯誤
      const childUrl = `${baseUrl}/api/v1/ocrAuth/loginRedirect`; 
      const base = `${baseUrl}/#/policy-info/PolicyInfo`;
      let innerUrl = `${base}?source=${btoa('parent')}`;
      if (familyId) {
        innerUrl = innerUrl + `&familyid=${btoa(familyId)}`;
      }
      const outerUrl = `${childUrl}?url=${encodeURIComponent(innerUrl)}`;
      console.log('URL = ' + outerUrl)

      const isApp = window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.openPushPage;

      if (isApp) {
        let categoryObj = {
          title: '手動輸入',
          url: outerUrl,
          page: 'PolicyHealth',
          funcName: 'addPolicy'
        };
        window.webkit.messageHandlers.openPushPage.postMessage(JSON.stringify(categoryObj));
      } else {
        this.openChildWindow(outerUrl, 'manual-input-window');
      }
    },

    openPhotoUploadWindow() {
      const familyId = this.getFamilyId();
      const baseUrl = this.getCrmBaseUrl();

      const childUrl = `${baseUrl}/api/v1/ocrAuth/loginRedirect`; 
      const base = `${baseUrl}/#/Policy-upload/PolicyUpload`;
      let innerUrl = `${base}?source=${btoa('parent')}`;

      if (familyId) {
        innerUrl = innerUrl + `&familyid=${btoa(familyId)}`;
      }

      const outerUrl = `${childUrl}?url=${encodeURIComponent(innerUrl)}`;

      const isApp = window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.openPushPage;

      if (isApp) {
        let categoryObj = {
          title: '拍照上傳',
          url: outerUrl,
          page: 'PolicyHealth',
          funcName: 'addPolicy'
        };
        window.webkit.messageHandlers.openPushPage.postMessage(JSON.stringify(categoryObj));
      } else {
        this.openChildWindow(outerUrl, 'photo-upload-window');
      }
    },

  openChildWindow(url, windowName) {
    // 如果視窗已經開啟且沒被關閉
    if (this.childWindow && !this.childWindow.closed) {
      try {
        // 嘗試聚焦，行動版效果有限
        this.childWindow.focus();
        alert('視窗已開啟，請切換分頁查看');
      } catch (e) {
        console.warn('無法聚焦舊視窗:', e);
      }
      return;
    }
    // 強制停止舊的監控計時器，避免第二次點擊時舊邏輯干擾
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    if (this.checkClosedInterval) {
      clearInterval(this.checkClosedInterval);
      this.checkClosedInterval = null;
    }
    
    // 判斷是否為行動裝置 (涵蓋 Android, iPhone, iPad)
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let childWindow = null;;

    if (isMobile) {
      // 行動版 Chrome 不支援指定寬高，帶了參數反而容易被視為彈出式廣告而攔截
      childWindow = window.open(url, windowName);
    } else {
      // 桌機版：保留原有的視窗置中計算與功能設定
      const screenWidth = window.screen.availWidth;
      const screenHeight = window.screen.availHeight;
      const windowWidth = 1200;
      const windowHeight = 800;
      const left = (screenWidth - windowWidth) / 2;
      const top = (screenHeight - windowHeight) / 2;
      const windowFeatures = [
        `width=${windowWidth}`,
        `height=${windowHeight}`,
        `left=${left}`,
        `top=${top}`,
        'scrollbars=yes',
        'resizable=yes'
      ].join(',');

      childWindow = window.open(url, windowName, windowFeatures);
    }
    this.childWindow = childWindow;
    if (!this.childWindow || this.childWindow.closed || typeof this.childWindow.closed === 'undefined') {
      alert('無法開啟子視窗，請檢查瀏覽器彈出視窗設定');
      return;
    }
    this.setupPostMessageListener();
    this.monitorChildWindow();
    this.startPollingForMessage();
  },
  handleManualInputComplete(data) {
    this.closeChildWindow();
    const contractId = this.extractFirstContractId(data);
    if (contractId) {
      this.navigateToTarget(contractId);
    } else {
      console.error('無法取得 contract_id');
    }
  },
  handlePhotoUploadComplete(data) {
    this.closeChildWindow();
    
    // 從 API 回應中取得第一筆 contract_id
    const contractId = this.extractFirstContractId(data);
    
    if (contractId) {
      this.navigateToTarget(contractId);
    } else {
      console.error('無法取得 contract_id');
    }
  },
  extractFirstContractId(data) {
    
    try {
      if (data && 
          data.payload && 
          data.payload.apiResponse && 
          data.payload.apiResponse.body && 
          Array.isArray(data.payload.apiResponse.body) && 
          data.payload.apiResponse.body.length > 0) {
        const contractId = data.payload.apiResponse.body[0].contract_id;
        return contractId;
      }
      if (data && 
          data.apiResponse && 
          data.apiResponse.body && 
          Array.isArray(data.apiResponse.body) && 
          data.apiResponse.body.length > 0) {
        return data.apiResponse.body[0].contract_id;
      }
      return null;
    } catch (error) {
      console.error('提取 contract_id 時發生錯誤:', error);
      return null;
    }
  },
  handleOperationCancelled() {
    this.closeChildWindow();
  },
  navigateToTarget(contractId) {
    const normalizedContractId = this.normalizeContractId(contractId);
    if (!normalizedContractId) {
      console.error('Invalid contract_id for navigation');
      return;
    }

    try {
      const targetUrl = new URL('/crm/', window.location.origin);
      targetUrl.hash = `/mv/familyRelation/policyInfo/edit-list?${new URLSearchParams({
        modify: normalizedContractId
      }).toString()}`;

      // A full reload is required so the destination page fetches current data.
      window.location.assign(targetUrl.toString());
    } catch (error) {
      console.error('路由跳轉失敗:', error);
    }
  },
  normalizeContractId(contractId) {
    if (typeof contractId !== 'string' && typeof contractId !== 'number') {
      return null;
    }

    const value = String(contractId).trim();
    // Contract IDs are identifiers, not paths or HTML. The router encodes
    // this validated value when it serializes the query string.
    return /^[A-Za-z0-9_-]{1,128}$/.test(value) ? value : null;
  },
  closeChildWindowAndNavigate(contractId) {
    this.closeChildWindow();
    if (contractId) {
      this.navigateToTarget(contractId);
    } else {
      console.error('無法導航：缺少 contract_id');
    }
  },
  closeChildWindow() {
    if (this.childWindow && !this.childWindow.closed) {
      this.childWindow.close();
    }
    this.cleanupCommunication();
  },
  monitorChildWindow() {
      // 如果之前有計時器，先清掉
    if (this.checkClosedInterval) clearInterval(this.checkClosedInterval);
      this.checkClosedInterval = setInterval(() => {
        // 判斷 this.childWindow 是否存在
        if (this.childWindow && this.childWindow.closed) {
          clearInterval(this.checkClosedInterval);
          this.checkClosedInterval = null;
          this.cleanupCommunication();
          // 視窗關閉後，將引用設為 null，下次點擊才不會出錯
          this.childWindow = null; 
        }
      }, 1000);
  },
  cleanupCommunication() {
    this.stopPolling();
    this.childWindow = null;
    this.communicationId = null;
  },
  getCrmBaseUrl() {
    const hostname = window.location.hostname;
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:8088';
    }
    if (hostname.includes('tmycrm')) {
      return 'https://tmycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
    }
    if (hostname.includes('smycrm')) {
      return 'https://smycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
    }
    if (hostname.includes('mycrm')) {
      return 'https://mycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
    }
    return 'https://mycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
  },
  /*async checkUnitStatus() {
    try {
      const result = await checkUnitExist(this.UserInfo.id, this.UserInfo.divNo);
      if (result.header.status == "200" && result.body) {
        this.unitExist = result.body.checkUnitExist;
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  },*/
  async checkUnitStatus() {
    try {
      const result = await checkOcrSwitch();
      if (result && result.header && result.header.status == "200" && result.body) {
        this.isOcrEnabled = result.body.isOcrEnabled;
      }
    } catch (error) {
      console.error("API Error:", error);
      this.isOcrEnabled = true; // 發生例外時，一律開啟
    }
  },  
  reloadWeb(urlStr) {
    this.closeChildWindow();
    // 建立 URL 物件
    const url = new URL(urlStr);

    // 參數在 # (hash) 後面，需要先處理 hash 部分
    const hashParts = url.hash.split('?');
    const params = new URLSearchParams(hashParts[1] || '');
    const modifyValue = params.get('modify');
    console.log('contract_id : ' + modifyValue);
    if (modifyValue) {
      this.navigateToTarget(modifyValue);
    } else {
      console.error('無法取得 contract_id');
    }
  }
},
  mounted() {
    // 判斷是否是app
    const isApp = !!(window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.openPushPage);

    if (isApp) {
      window.reloadWeb = (urlStr) => {
        try {
          if (this && typeof this.reloadWeb === 'function') {
            this.reloadWeb(urlStr);
            return "success";
          }
          return "instance_not_found";
        } catch (e) {
          console.error(e);
          return "error";
        }
      };
    }
  },
  computed: {
    ...mapGetters(["UserInfo", "BaseUrl"]),
  },
  created() {
    this.checkUnitStatus();
  },
  beforeDestroy() {
      if (window.reloadWeb) {
        window.reloadWeb = null;
      }
    }
};
</script>
<style scoped>
.new-tag-icon {
  position: absolute;
  top: -2px;   
  left: -2px; 
  width: 60px; 
  height: auto;
  z-index: 10; 
}
</style>
